module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.woff2?8dc1cedf1f4987f82b7284beb2cd23fa";